import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="flex h-screen bg-gray-50" data-id="element-118">
      <Sidebar isMobileMenuOpen={isMobileMenuOpen} onCloseMobileMenu={() => setIsMobileMenuOpen(false)} data-id="element-119" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-120">
        <Header onToggleMobileMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-121" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-122">{children}</main>
      </div>
    </div>;
};
export default Layout;